import React from 'react';
import { Helmet } from 'react-helmet';
import {
  DEFAULT_IMAGE,
  getRouteSeo,
  SITE_URL,
} from '../../config/routeSeo';

export { DEFAULT_IMAGE, SITE_URL };

const toCanonicalUrl = (canonicalPath) => {
  if (!canonicalPath) return null;
  if (/^https?:\/\//i.test(canonicalPath)) return canonicalPath;
  const normalizedPath = canonicalPath.startsWith('/')
    ? canonicalPath
    : `/${canonicalPath}`;
  return `${SITE_URL}${normalizedPath}`;
};

const PageSeo = ({
  title,
  description,
  canonicalPath,
  image = DEFAULT_IMAGE,
  robots = 'index, follow, max-image-preview:large',
  type = 'website',
  imageAlt,
  routePath,
}) => {
  const routeSeo = routePath ? getRouteSeo(routePath) : null;
  const resolvedTitle = title || routeSeo?.title;
  const resolvedDescription = description || routeSeo?.description;
  const resolvedCanonicalPath = canonicalPath || routeSeo?.canonicalPath;
  const resolvedImage = image || routeSeo?.image || DEFAULT_IMAGE;
  const resolvedRobots = robots || routeSeo?.robots;
  const resolvedType = type || routeSeo?.type;
  const canonicalUrl = toCanonicalUrl(resolvedCanonicalPath);
  const resolvedImageAlt = imageAlt || resolvedTitle;

  return (
    <Helmet>
      <html lang="uk" />
      <title>{resolvedTitle}</title>
      <meta name="description" content={resolvedDescription} />
      <meta name="robots" content={resolvedRobots} />

      {canonicalUrl && <link rel="canonical" href={canonicalUrl} />}

      <meta property="og:type" content={resolvedType} />
      <meta property="og:site_name" content="BigSPORT" />
      <meta property="og:locale" content="uk_UA" />
      <meta property="og:title" content={resolvedTitle} />
      <meta property="og:description" content={resolvedDescription} />
      {canonicalUrl && <meta property="og:url" content={canonicalUrl} />}
      <meta property="og:image" content={resolvedImage} />
      <meta property="og:image:alt" content={resolvedImageAlt} />

      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={resolvedTitle} />
      <meta name="twitter:description" content={resolvedDescription} />
      <meta name="twitter:image" content={resolvedImage} />
      <meta name="twitter:image:alt" content={resolvedImageAlt} />
    </Helmet>
  );
};

export default PageSeo;
